import {Action} from '@ngrx/store';

export const PAGE_STATE_RESET = '[DokumentePage] Page State reset';
export const IGNORE_WS_ACTION = '[DokumentePage] WS Action ignoriert';
export const PAGE_DATEN_LADEN = '[DokumentePage] Page Daten Laden';
export const DOKUMENT_SUCHEN = '[DokumentePage] Dokument suchen';
export const TOGGEL_DOKUMENTE_GROUP_ACTION = '[DokumentePage] Toggle Dokumente-Group';

// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// IGNORE WS ACTION
export class IgnoreWSAction implements Action {
    readonly type = IGNORE_WS_ACTION;

    constructor(public payload: any) {
    }
}

export class PageLoadDataAction implements Action {
    readonly type = PAGE_DATEN_LADEN;

    constructor() {
    }
}

export class DokumentSuchenAction implements Action {
    readonly type = DOKUMENT_SUCHEN;

    constructor(public filterString: string) {
    }
}

export class ToggleDokumenteGroupAction implements Action {
    readonly type = TOGGEL_DOKUMENTE_GROUP_ACTION;

    constructor(public dokumenteGroupKey: string) {
    }
}


/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    PageStateResetAction
    | IgnoreWSAction
    | PageLoadDataAction
    | DokumentSuchenAction
    | ToggleDokumenteGroupAction
    ;
